"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAccessToken = void 0;
var verifyToken_1 = require("./verifyToken");
var verifyAccessToken = function (args) { return (0, verifyToken_1.verifyToken)(args); };
exports.verifyAccessToken = verifyAccessToken;
